import { reactive } from "vue";
import { createLoading } from "../../../../utils/loading";
import { modalStyleForm } from "../../../../utils/constant";
import store from "../../../../store";
import { setAppPageHeader } from "../../../../components/layout/app-layout/app-layout.logic";
import { addModal, setIsLoading as setIsLoadingApp } from "../../../../app.logic";
import i18n from "../../../../i18n";
import { notification, Input, Spin } from "ant-design-vue";
import lodash from "lodash";
import { createPage } from "../../../../utils/page";
import { createButtonSave } from "../../../../utils/button";

const propertyTypes = [
    {
        type: "Image",
        test: ({ appProperty }) => {
            const groupKeys = [
                { group: "APP", key: "BRAND" },
                { group: "APP", key: "LOGO" },
                { group: "APP", key: "FAVICON" }
            ];
            return groupKeys.find(d => d.group === appProperty.group && d.key === appProperty.key);
        },
        afterMatch({ appProperty }) {
            appProperty.image = {
                url: appProperty.value
            };
        },
        customRequest({ appProperty }) {
            if (appProperty.key === "BRAND") {
                return callUpdateBrand({ data: appProperty.image });
            } else if (appProperty.key === "LOGO") {
                return callUpdateLogo({ data: appProperty.image });
            } else if (appProperty.key === "FAVICON") {
                return callUpdateFavicon({ data: appProperty.image });
            }
        }
    }
];

const loading = createLoading();
export const { setIsLoading } = loading;

export const callSearch = ({ criteria }) => store.dispatch(`resource/v1/security/appProperty/search`, { criteria });
export const callSave = ({ data }) => store.dispatch(`resource/v1/security/appProperty/save`, { data });
export const callUpdateBrand = ({ data }) => store.dispatch(`resource/v1/security/appProperty/updateBrand`, { data });
export const callUpdateLogo = ({ data }) => store.dispatch(`resource/v1/security/appProperty/updateLogo`, { data });
export const callUpdateFavicon = ({ data }) => store.dispatch(`resource/v1/security/appProperty/updateFavicon`, { data });
export const callTestEmail = ({ data }) => store.dispatch(`resource/v1/security/appProperty/testEmail`, { data });
export const callGetServerInfo = () => store.dispatch(`resource/server/getInfo`, { options: { force: true } });

export const onClickSave = ({ data, onSearch }) => {
    setIsLoadingApp(true);
    const appProperties = data.page.data.filter(d => d.isSave);
    const requests = appProperties.map(appProperty => {
        const propertyType = appProperty.propertyType;
        if (propertyType?.customRequest) {
            return propertyType?.customRequest({ appProperty, propertyType });
        } else {
            return callSave({ data: appProperty });
        }
    });
    Promise.all(requests)
        .finally(() => setIsLoadingApp(false))
        .then(() => {
            onSearch(data);
            callGetServerInfo();
            notification["success"]({ message: i18n.global.t("views.setting.application.success") });
        });
};

export const onClickTestEmail = ({ data }) => {
    openModalTestEmail({ data });
};

export const createOnSearch = ({ data }) => {
    return ({ page }) => {
        const where = [
            { name: "isActive", type: "Boolean", operator: "=", value: true },
            { name: "group", type: "String", operator: "in", value: data.tabs }
        ];
        setIsLoading(true);
        return callSearch({ criteria: { ...page, where } })
            .then(page => {
                page.data.forEach(appProperty => {
                    const propertyType = propertyTypes.find(propertyType => propertyType.test({ appProperty }));
                    propertyType?.afterMatch?.({ appProperty, propertyType });
                    appProperty.propertyType = propertyType;
                });
                data.page = page;
            })
            .finally(() => setIsLoading(false));
    };
};

export const createData = () => {
    return reactive({
        isLoading: loading.isLoading,
        page: createPage({ options: { sort: [{ name: "seq", type: "ASC" }], size: 1000000 } }),
        tabs: ["APP", "LESS_VAR", "SMTP","TOGGLE"]
    });
};

export const initForm = ({ data, onSearch }) => {
    const vnodes = [];
    vnodes.push(createButtonSave({ onClick: () => onClickSave({ data, onSearch }), classStyle: "m-1" }));
    setAppPageHeader({
        slots: {
            default: () => <div class="d-flex">{...vnodes}</div>
        }
    });
};

export const getList = ({ data, group }) => {
    return data.page.data.filter(d => d.group === group);
};

export const openModalTestEmail = ({ data }) => {
    const form = reactive({ to: null, spinning: false });
    data.page.data
        .filter(d => d.group === "SMTP")
        .forEach(d => {
            form[lodash.camelCase(d.key)] = d.value;
        });
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleForm), {
            title: i18n.global.t("button.testEmail"),
            width: "520px",
            okText: i18n.global.t("button.testEmail"),
            onOk: () => {
                if (!form.to) {
                    notification["error"]({ message: i18n.global.t("views.setting.application.tab.SMTP.email.required") });
                    return;
                }
                form.spinning = true;
                callTestEmail({ data: form })
                    .finally(() => (form.spinning = false))
                    .then(() => {
                        notification["success"]({ message: i18n.global.t("views.setting.application.tab.SMTP.email.success") });
                        options.bind.onCancel();
                    });
            }
        }),
        render: () => (
            <Spin spinning={form.spinning}>
                <Input value={form.to} onUpdate:value={value => (form.to = value)} placeholder={i18n.global.t("model.user.email")}></Input>
            </Spin>
        )
    });
    return options;
};
